import React from "react";

// 🔁 Convert object to CSV and trigger download
export const exportDashboardCSV = (metrics) => {
    const labels = [
        { key: "loginFiles", label: "Login" },
        { key: "notAssignedFiles", label: "Not Assigned Files" },
        { key: "completedFiles", label: "Completed" },
        { key: "lastMonthLoginFiles", label: "Last Month Login Files" },
        { key: "lastMonthCompletedFiles", label: "Last Month Completed Files" },
        { key: "assignedFiles", label: "Assigned Files" },
        { key: "queryNotRaisedFiles", label: "Query Not Raised Files" },
    ];

    const header = ["", "FTD", "MTD", "YTD"];
    const rows = labels?.map((item) => [
        item.label,
        metrics.FTD[item.key],
        metrics.MTD[item.key],
        metrics.YTD[item.key],
    ]);

    const csvData = [header, ...rows]
        ?.map((row) => row.join(","))
        .join("\n");

    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const now = new Date();
    const timestamp = now
        .toLocaleString("en-GB") // Format: DD/MM/YYYY, HH:mm:ss
        .replace(/[/,: ]/g, "_"); // Replace `/`, `,`, `:` and space with `_`

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `AdminDashboardSummary_${timestamp}.csv`); document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
